import * as React from 'react'

import Box from '@mui/material/Box'
import List from '@mui/material/List'
import Popover from '@mui/material/Popover'
import ListItem from '@mui/material/ListItem'
import ListItemText from '@mui/material/ListItemText'
import { LightTooltip } from '@sales-center/components'

interface Props {
  anchorEl: Element | null
  onClose: () => void
  onClosedLostClick: () => void
  onClosedWonClick: () => void
  opportunityId: number
  open: boolean
  disableCloseWon?: boolean
  notCloseableMessage?: string
}

export const ClosedWonLostMenu: React.FC<Props> = (props: Props) => {
  const {
    anchorEl,
    open,
    onClose,
    onClosedLostClick,
    onClosedWonClick,
    disableCloseWon,
    notCloseableMessage,
  } = props

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      elevation={2}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
    >
      <List
        sx={{ width: 200 }}
        component="nav"
        aria-label="secondary mailbox folders"
        dense
      >
        {disableCloseWon ? (
          <LightTooltip placement="top-start" title={notCloseableMessage}>
            <Box>
              <ListItem
                disabled={disableCloseWon}
                button
                data-test-id="closedWonListItem"
              >
                <ListItemText primary="Closed Won" onClick={onClosedWonClick} />
              </ListItem>
            </Box>
          </LightTooltip>
        ) : (
          <ListItem button data-test-id="closedWonListItem">
            <ListItemText primary="Closed Won" onClick={onClosedWonClick} />
          </ListItem>
        )}
        <ListItem button data-test-id="closedLostListItem">
          <ListItemText primary="Closed Lost..." onClick={onClosedLostClick} />
        </ListItem>
      </List>
    </Popover>
  )
}

ClosedWonLostMenu.displayName = 'ClosedWonLostMenu'
